import { render, staticRenderFns } from "./TextareaInputComponent.vue?vue&type=template&id=46596a1a&"
import script from "./TextareaInputComponent.vue?vue&type=script&lang=js&"
export * from "./TextareaInputComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports